import styles from './admin-contracts.module.scss';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { UseTableHook } from '../../requestUtils';
import ContractsGrid from '../contracts-grid/contracts-grid';
import PageTitle from '../../page-title/page-title';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import { addMonths } from 'date-fns/esm';
import { IContracts } from '../../_models/contracts';
import ContractsGridSkeleton from '../contracts-grid/contracts-grid-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ContractsProps { }

export function Contracts(props: ContractsProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const { data, getData, onDateChange, isLoading, dateRange } = UseTableHook<IContracts>(`admin/contracts`, { startDate: new Date(), endDate: addMonths(new Date(), 1), ignoreCompany: true })

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.contracts")} subtitle={`(${t("standard.admin")})`} showNoCompanyMessage={!currentCompany} />
            {isLoading ?
              <ContractsGridSkeleton isLoading /> :
              <ContractsGrid
                contracts={data}
                onDateChange={onDateChange}
                getData={getData}
                dateRange={dateRange}
              />
            }
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Contracts;